import { render, staticRenderFns } from "./zoho-dashboard.vue?vue&type=template&id=772e62f6&scoped=true&"
import script from "./zoho-dashboard.vue?vue&type=script&lang=js&"
export * from "./zoho-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./zoho-dashboard.vue?vue&type=style&index=0&id=772e62f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772e62f6",
  null
  
)

export default component.exports